import * as React from "react";
import styled, { css } from "styled-components";
import { forwardRef } from "react";
import Icon from "components/common/Icon";
const Wrapper = styled.button(
  ({ theme, disabled }) => css`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    width: 25px;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    color: ${disabled ? theme.colors.gray[90] : theme.colors.gray[60]};
    font-size: ${theme.fonts.size.large};

    &:hover {
      background-color: ${theme.colors.gray[80]};
    }

    &:active {
      background-color: ${theme.colors.gray[70]};
    }
  `
);
const handleClick = (onClick, e) => {
  if (typeof onClick === "function") {
    onClick(e);
  }
};
const IconButton = ({
  title,
  onClick = void 0,
  focusable = true,
  className = void 0,
  disabled = false,
  iconType = void 0,
  "data-testid": dataTestId = void 0,
  ...rest
}, ref) => /* @__PURE__ */ React.createElement(
  Wrapper,
  {
    ref,
    tabIndex: focusable ? 0 : -1,
    "data-testid": dataTestId,
    title,
    "aria-label": title,
    onClick: (e) => handleClick(onClick, e),
    className,
    type: "button",
    disabled
  },
  /* @__PURE__ */ React.createElement(Icon, { type: iconType, ...rest })
);
export default forwardRef(IconButton);
